import { useCallback } from "react";

export const useNumericInput = (maxLength = 13) => {
  const handleNumericInput = useCallback(
    (e: any, callback: any) => {
      const { value, name } = e.target;

      // Remove non-digit characters
      const numericValue = value.replace(/\D/g, "");

      // Limit to maxLength digits
      if (numericValue.length <= maxLength) {
        // Pass cleaned value to the form handler
        callback({
          target: {
            name,
            value: numericValue,
          },
        });
      }
    },
    [maxLength],
  );

  return handleNumericInput;
};
